import client from './client';

export const getMyVote = async (gameId, roundId) => {
  const response = await client.get(`/api/games/${gameId}/rounds/${roundId}/votes/me`);
  return response.data;
};

export const castVote = async (gameId, roundId, mvpUserId) => {
  const response = await client.put(`/api/games/${gameId}/rounds/${roundId}/votes/me`, {
    mvpUserId
  });
  return response.data;
};

export const getVotingStatus = async (gameId, roundId) => {
  const response = await client.get(`/api/games/${gameId}/rounds/${roundId}/votes/status`);
  return response.data;
};

export const getVotingResults = async (gameId, roundId) => {
  const response = await client.get(`/api/games/${gameId}/rounds/${roundId}/votes/results`);
  return response.data;
};

export const getVotableParticipants = async (gameId, roundId) => {
  const response = await client.get(`/api/games/${gameId}/rounds/${roundId}/votes/participants`);
  return response.data;
};
